module.exports = __webpack_public_path__ + "static/img/h-6.2a48fd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/h-6.jpg
// module id = B6K1
// module chunks = 1